"use strict";

exports.TransactionUtility = void 0;
var _ProtocolError = require("./data/errors/ProtocolError");
var _sdkTypes = require("./data/sdk-types");
var _logger = require("./logger");
var _TransactionHttpRepository = require("./repositories/TransactionHttpRepository");
class TransactionUtility {
  constructor(props) {
    if (!props) {
      throw new _ProtocolError.ProtocolError('props are required', {
        component: _sdkTypes.ErrorContextComponent.SDK_TRANSACTION_UTILITY,
        description: 'Props required to initialize TransactionUtility were not provided'
      });
    }
    this.logger = new _logger.Logger('@presend/verification/transaction-util', props.debug);
    this.transactionHttpRepo = new _TransactionHttpRepository.TransactionHttpRepository();
  }

  /**
   * A function takes a source address and returns a list of all transactions from that source address.
   *
   * @param {string} sourceAddress - The source address
   * @return {Promise<PreSendTransaction[]>} - List of all transactions from the source address
   */
  async getTransactionHistoryBySourceAsync(sourceAddress) {
    this.logger.debug('Getting transaction history for source Address', sourceAddress);
    const history = await this.transactionHttpRepo.getTransactionHistoryBySourceAsync(sourceAddress);
    this.logger.debug('Got transaction history source address', sourceAddress);
    return history;
  }

  /**
   * A function that returns a list of all transactions.
   *
   * @return {Promise<PreSendTransaction[]>} - List of all transactions
   */
  async getAllTransactionHistoryAsync() {
    this.logger.debug('Getting transaction history');
    const history = await this.transactionHttpRepo.getTransactionHistory();
    this.logger.debug('Got transaction history');
    return history;
  }

  /**
   * A function that that takes an affiliate address and return all associated transaction.
   *
   * @param {string} affiliateAddress - The affiliate address
   * @return {Promise<PreSendTransaction[]>} - List of all transactions which contains the affiliate address
   */
  async getTransactionHistoryByAffiliateAsync(affiliateAddress) {
    this.logger.debug('Getting transaction history for affiliate Address', affiliateAddress);
    const history = await this.transactionHttpRepo.getTransactionHistoryByAffiliateAsync(affiliateAddress);
    this.logger.debug('Got transaction history for affiliate address', affiliateAddress);
    return history;
  }
}
exports.TransactionUtility = TransactionUtility;